module.exports = __webpack_public_path__ + "static/img/payment-visa.4db39a16.svg";